export const MEMBER_DISPATCHES = {
  login: "LOGIN",
  changeTargetMember: "CHANGE_TARGET_MEMBER",
  updateList: "UPDATE_LIST",
  updateCID: "UPDATE_CID",
  updateSeconds: "UPDATE_SECONDS",
  updateStart: "UPDATE_START",
  updateEncounterContent: "UPDATE_ENCOUNTER_CONTENT",
  updateEncounterNoteOpen: "UPDATE_ENCOUNTER_NOTE_OPEN",
  updateRecents: "UPDATE_RECENTS",
  updateAcknowledged: "UPDATE_ACKNOWLEDGED"
};

function memberReducer(state: any, { type, payload }: any) {
  switch (type) {
    case MEMBER_DISPATCHES.login:
      return { ...state, ...payload };
    case MEMBER_DISPATCHES.changeTargetMember:
      return { ...state, current: payload };
    case MEMBER_DISPATCHES.updateList:
      return { ...state, list: payload };
    case MEMBER_DISPATCHES.updateCID:
      return { ...state, cid: payload };
    case MEMBER_DISPATCHES.updateSeconds:
      return { ...state, secondsCounter: payload };
    case MEMBER_DISPATCHES.updateStart:
      return { ...state, encounterStart: payload };
    case MEMBER_DISPATCHES.updateEncounterContent:
      return { ...state, notesContent: payload };
    case MEMBER_DISPATCHES.updateEncounterNoteOpen:
      return { ...state, noteOpen: payload };
    case MEMBER_DISPATCHES.updateRecents:
      return { ...state, recents: payload };
    case MEMBER_DISPATCHES.updateAcknowledged:
      return {
        ...state,
        current: {
          ...state.current,
          acknowledged: payload.acknowledged
        },
        list: state.list.map((targetMember: any) =>
          targetMember._id === payload._id ? { ...targetMember, acknowledged: payload.acknowledged } : targetMember
        )
      };
    default:
      return state;
  }
}

export default memberReducer;
